export const rightSideBarTypes = {
  pendingPayment: 'pending_payment',
  futureWork: 'future_work',
  earnThisMonth: 'earned_this_month',
};
